import React from "react";
import { RCCTab } from "react-common-components";
import IComponentTabs from "react-common-components/dist/components/Tab/interface";

const Tabs: React.FC<IComponentTabs> = ({
	...rest
}) => <RCCTab
	colorTextTab="purpleLighter"
	colorBorderTab="purpleLighter"
	elevation={false}
	{...rest}
/>;

export default Tabs;
